<div class="toolbar-services grid grid-rows-1 grid-cols-1 sm:w-20 xl:w-28 py-4 bg-black">
  <div class="grid grid-rows-auto grid-cols-1">
    <app-toolbar-item-activities *ngFor="let menuItem of toolbarServiceItem" 
    [item]="menuItem" (click)="getActivity(menuItem.msg)">
    </app-toolbar-item-activities>
  </div>
</div>
